import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { UserMarketingSetting,  } from '@model';
import { environment } from 'environments/environment';
import { SxErrorService } from 'app/services/sx-error.service';

@Injectable({
  providedIn: 'root'
})
export class UserMarketingSettingsService {

  constructor(private http: HttpClient, private sxErrorService: SxErrorService) {}

  GetMyMarketingSettings(): Observable<UserMarketingSetting> {
    return this.http
      .get<UserMarketingSetting>(`${environment.apiEndpoint}/UserMarketingSettings`)
      .pipe(catchError((error: any) => this.sxErrorService.handleError(error)));
  }

  UpdateMyMarketingSettings(userMarketingSetting: UserMarketingSetting): Observable<UserMarketingSetting> {
    return this.http
      .post<UserMarketingSetting>(`${environment.apiEndpoint}/UserMarketingSettings/${userMarketingSetting.id}`, userMarketingSetting)
      .pipe(catchError((error: any) => this.sxErrorService.handleError(error)));
  }
}
